import withModal from '../PF2MModal/withModal';
import TruckStatus from './TruckModal';
import ExcavatorStatus from './ExcavatorModal';

export const TruckModal = withModal(TruckStatus);
export const ExcavatorModal = withModal(ExcavatorStatus);
export const LoaderModal = withModal(ExcavatorModal);
